module.exports = __webpack_public_path__ + "img/MeterWorkOrders-Office.7a190833.png";